<template>
	<div class="container">
		<div class="main_box">
			<div class="form_box">
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px">
					<div class="input_el">
						<div class="tit required">Step Type</div>
						<el-form-item label="" prop="flow_leixing">
							<el-select disabled v-model="ruleForm.flow_leixing" placeholder="Please Select" style="width: 100%;">
								<el-option label="Approval" :value="1"></el-option>
								<el-option label="CC" :value="2"></el-option>
							</el-select>
						</el-form-item>
					</div>
		
					<div class="input_el">
						<div class="tit required">Step Name</div>
						<el-form-item label="" prop="title">
							<el-input v-model="ruleForm.title" placeholder="Please Enter" clearable></el-input>
						</el-form-item>
					</div>
		
					<div class="input_el">
						<div class="tit required">Step Description</div>
						<el-form-item label="" prop="prompt">
							<el-input
								type="textarea"
								:rows="3"
								v-model="ruleForm.prompt"
								placeholder="Please Enter"
								clearable
							></el-input>
						</el-form-item>
					</div>
		
					<div class="input_el">
						<div class="tit required">
							{{ ruleForm.flow_leixing == 1 ? 'Approval Type' : 'CC Type' }}
						</div>
						<el-form-item label="" prop="flow_type">
							<el-select
								v-model="ruleForm.flow_type"
								placeholder="Please Select"
								style="width: 100%;"
								@change="flowTypeChange"
							>
								<!-- <el-option label="Company Manager" :value="1"></el-option>
								<el-option label="Management Representative" :value="2"></el-option> -->
								<el-option label="Department Manager" :value="3"></el-option>
							</el-select>
						</el-form-item>
					</div>
		
					<!-- <div v-if="ruleForm.flow_type == 1 || ruleForm.flow_type == 2" class="input_el">
						<div class="tit required">
							{{ ruleForm.flow_leixing == 1 ? 'Approval Company' : 'CC Company' }}
						</div>
						<el-form-item label="" prop="flow_ids">
							<el-select
								v-model="ruleForm.flow_ids"
								placeholder="Please Select"
								style="width: 100%;"
								@change="companyCheck"
							>
								<el-option
									v-for="value in companyList"
									:key="value.id"
									:label="value.company_name"
									:value="value.id"
								></el-option>
							</el-select>
						</el-form-item>
					</div> -->
		
					<!-- <div v-if="ruleForm.flow_type == 3" class="input_el">
						<div class="tit required">
							{{ ruleForm.flow_leixing == 1 ? 'Approval Company' : 'CC Company' }}
						</div>
						<el-form-item label="">
							<el-select
								v-model="companyId"
								placeholder="Please Select"
								style="width: 100%;"
								@change="getDepartment(companyId)"
							>
								<el-option
									v-for="value in companyList"
									:key="value.id"
									:label="value.company_name"
									:value="value.id"
								></el-option>
							</el-select>
						</el-form-item>
					</div> -->
		
					<div v-if="ruleForm.flow_type" class="input_el">
						<div class="tit required">
							{{ ruleForm.flow_leixing == 1 ? 'Approval Department' : 'CC Department' }}
						</div>
						<el-form-item label="">
							<el-select
								v-model="ruleForm.flow_ids"
								multiple
								placeholder="Please Select"
								style="width: 100%;"
								@change="departmentsCheck"
							>
								<el-option
									v-for="value in departmentsList"
									:key="value.id"
									:label="value.departments_name"
									:value="value.id"
								></el-option>
							</el-select>
						</el-form-item>
					</div>
		
					<div class="input_el">
						<div class="tit required">
							{{ ruleForm.flow_leixing == 1 ? 'Approver(s)' : 'CC Recipient(s)' }}
						</div>
						<el-form-item label="">
							<el-select
								disabled
								v-model="ruleForm.flow_uid"
								filterable
								multiple
								placeholder="Please Select"
								style="width: 100%;"
							>
								<el-option
									v-for="value in usersList"
									:key="value.id"
									:label="value.user_name"
									:value="value.id"
								></el-option>
							</el-select>
						</el-form-item>
					</div>
				</el-form>
			</div>
		
			<div class="btn_box">
				<!-- <van-button class="btn_el" type="default" round @click="cancel">Cancel</van-button> -->
				<van-button
					class="btn_el"
					round
					color="linear-gradient(to right, #7BC1FF, #4886FF)"
					@click="submitForm('ruleForm')"
				>
					Save
				</van-button>
			</div>
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import { flowAdd, flowEdit } from '@/api/docManage/configureDocControl/docFlow/index';
// import { companyList } from '@/api/system/company';
import { departmentsList } from '@/api/system/department';
export default {
	props: ['leixingId', 'flowType', 'listData', 'leixingTpye'],
	components:{},
	data() {
		return {
			isLoading: true,
			// companyId: '',
			ruleForm: {
				title: '',
				flow_leixing: '',
				prompt: '',
				flow_type: '',
				flow_ids: [],
				flow_uid: []
			},
			rules: {
				title: [
					{ required: true, message: 'Please enter', trigger: 'blur' },
				],
				prompt: [
					{ required: true, message: 'Please enter', trigger: 'blur' },
				],
				flow_leixing: [
					{ required: true, message: 'Please select', trigger: 'change' },
				],
				flow_type: [
					{ required: true, message: 'Please select', trigger: 'change' },
				],
				flow_ids: [
					{ required: true, message: 'Please select', trigger: 'change' },
				],
				flow_uid: [
					{ required: true, message: 'Please select', trigger: 'change' },
				]
			},
			// companyList: [],
			departmentsList: [],
			usersList: []
		}
	},
	created(){
		let that = this;
		// companyList({ page: 1, page_size: 9999, status: 1, company_name: '', company_userid: '', manage_userid: '' }).then(res => {
		// 	if(res.code == 200) {
				// that.companyList = res.data.data;
				if(that.flowType == 'Edit') {
					that.ruleForm = {
						id: that.listData.id,
						title: that.listData.title,
						flow_leixing: that.listData.flow_leixing,
						prompt: that.listData.prompt,
						flow_type: that.listData.flow_type
					}
					if(that.ruleForm.flow_type == 3) {
						//部门负责人
						// that.companyId = Number(that.listData.flow_company_id);
						that.getDepartment(that.listData.flow_ids);
					}else {
						//企业/管代负责人
						that.ruleForm.flow_ids = Number(that.listData.flow_ids);
						// that.companyCheck();
					}
				}else {
					that.ruleForm.flow_leixing = that.leixingTpye;
				}
		// 	}
		// });
		that.isLoading = false;
	},
	mounted() {
		let that = this;
	},
	watch: {
		//
	},
	methods: {
		//审批类型变换
		flowTypeChange() {
			let that = this;
			// that.companyId = '';
			that.ruleForm.flow_uid = [];
			that.ruleForm.flow_ids = [];
			that.usersList = [];
			//获取部门
			that.getDepartment();
		},
		//企业选择
		// companyCheck() {
		// 	let that = this;
		// 	//设置审批人
		// 	that.usersList = [];
		// 	that.ruleForm.flow_uid = [];
		// 	switch(that.ruleForm.flow_type) {
		// 		case 1:
		// 			that.companyList.forEach((value, index) => {
		// 				if(value.id == that.ruleForm.flow_ids) {
		// 					that.usersList = [{ user_name: value.company_username, id: value.company_userid }];
		// 					that.ruleForm.flow_uid.push(value.company_userid);
		// 				}
		// 			});
		// 		break;
		// 		case 2:
		// 			that.companyList.forEach((value, index) => {
		// 				if(value.id == that.ruleForm.flow_ids) {
		// 					that.usersList = [{ user_name: value.manage_username, id: value.manage_userid }];
		// 					that.ruleForm.flow_uid.push(value.manage_userid);
		// 				}
		// 			});
		// 		break;
		// 	}
		// },
		//部门选择
		departmentsCheck(value) {
			let that = this;
			that.$toast.loading({ duration: 0, forbidClick: true });
			that.usersList = [];
			that.ruleForm.flow_uid = [];
			let uniqueResults = [...new Map(
			  that.departmentsList.filter(item => that.ruleForm.flow_ids.includes(item.id))
			   .map(item => [item.id, item])
			).values()];
			let uList = [];
			uniqueResults.forEach((value, index) => {
				uList.push({ user_name: value.resources_username, id: value.resources_userid });
			});
			that.usersList = [...new Map(uList.map(item => [item.id, item])).values()];
			that.usersList.forEach((value, index) => {
				that.ruleForm.flow_uid.push(value.id);
			});
			that.$toast.clear();
		},
		//获取部门
		getDepartment(val) {
			let that = this;
			that.ruleForm.flow_ids = [];
			that.ruleForm.flow_uid = [];
			that.departmentsList = [];
			that.$toast.loading({ duration: 0, forbidClick: true });
			departmentsList({ page: 1, page_size: 9999, status: 1, departments_name: '', departments_userid: '' }).then(res2 => {
				that.$toast.clear();
				that.departmentsList = res2.data.data;
				if(val) {
					let arr = val.split(',').map(Number);
					that.ruleForm.flow_ids = arr;
					that.departmentsCheck(arr);
				}
			});
		},
		//保存
		submitForm(formName) {
			let that = this;
			that.$refs[formName].validate((valid) => {
				if(valid) {
					if(that.ruleForm.flow_ids.length == 0) { that.$toast('Please complete information first'); return false; }
					if(that.ruleForm.flow_uid.length == 0) { that.$toast('Please complete information first'); return false; }
					let query = {
						leixing_id: that.leixingId,
						title: that.ruleForm.title,
						prompt: that.ruleForm.prompt,
						flow_leixing: that.ruleForm.flow_leixing,
						flow_type: that.ruleForm.flow_type,
						flow_uid: that.ruleForm.flow_uid.join(','),
					};
					if(that.ruleForm.flow_type == 3) {
						// query.flow_ids = that.companyId + '_' + that.ruleForm.flow_ids.join(',');
						query.flow_ids = that.ruleForm.flow_ids.join(',');
					}else {
						query.flow_ids = that.ruleForm.flow_ids;
					}
					that.$toast.loading({ duration: 0, forbidClick: true });
					if(that.flowType == 'Add') {
						flowAdd(query).then(res => {
							if(res.code == 200) {
								that.$toast.clear();
								that.$message.success('Operation successful');
								setTimeout(() => {
									window.location.reload();
								}, 800);
							}else {
								
							}
						});
					}else if(that.flowType == 'Edit') {
						query.id = that.ruleForm.id;
						flowEdit(query).then(res => {
							if(res.code == 200) {
								that.$toast.clear();
								that.$message.success('Operation successful');
								setTimeout(() => {
									window.location.reload();
								}, 800);
							}else {
								
							}
						});
					}
				}else {
					return false;
				}
			});
		}
	}
}
</script>

<style lang="less" scoped>
//主要内容
.main_box{
	.btn_box{
		text-align: right;
		.btn_el{
			margin-left: 10px;
			padding: 12px 24px;
			.van-button__text{
				font-size: 16px;
			}
		}
	}
	.form_box{
		.input_el{
			.tit{
				padding-bottom: 5px;
				font-size: 14px;
				color: #333333;
			}
			.required::before {
				content: '*';
				color: red;
				margin-right: 2px;
			}
		}
	}
	.btn_el{
		margin: 10px 0 20px 0;
		.tips{
			padding: 6px 8px;
			background-color: #ffb1001a;
			border-radius: 6px;
			font-size: 16px;
			font-weight: bold;
		}
	}
}
</style>

